<template>
    <div>
        <checkbox
            v-model="checked"
            :checked="checked"
            :label="trans('security.checked')"
            name="2fa"
            @input="generateKey"
            :class="{ 'u-margin-bottom-narrow': checked }"
        />

        <div v-if="showLoader" class="qr-loader">
            <span class="qr-loader__ring"></span>
        </div>

        <qr-component v-if="showForm" :secret="user.two_factor_authentication_secret" :user="user.email" />

        <form v-if="showForm" @submit.prevent="checkCode">
            <div class="u-flex-end">
                <text-input
                    v-model="form.code"
                    :error="form.errors.first('code')"
                    name="code"
                    class="u-margin-right-narrow"
                    input-class="field__input field__input--search"
                    required
                />
                <div class="field__search-link">
                    <button :disabled="!form.code" type="submit" class="btn btn--blue btn--search">
                        {{ trans('security.check') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { QrComponent } from 'relapp-qr-code';

export default {
    components: {
        QrComponent
    },
    props: {
        user: {
            type: Object
        },
        loading: {
            type: Boolean
        },
        form: {
            type: Object,
            default: () => {}
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            checked: null
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.checked = !!this.user.two_factor_authentication_validated;
    },
    computed: {
        /**
         * Show the two factor authentication form.
         *
         * @return {boolean}
         */
        showForm() {
            return (
                this.checked &&
                !this.user.two_factor_authentication_validated &&
                this.user.two_factor_authentication_secret
            );
        },
        /**
         * Show the load spinner.
         *
         * @return {boolean}
         */
        showLoader() {
            return this.loading && this.checked && !this.user.two_factor_authentication_secret;
        }
    },
    methods: {
        /**
         * Trigger an event to check the authentication code.
         */
        checkCode() {
            this.$emit('checkAuthenticationCode', this.form);
        },
        /**
         * Trigger an event to generate the authentication code.
         *
         * @param {boolean} checked
         */
        generateKey(checked) {
            if (this.user.two_factor_authentication_validated == checked) {
                return;
            }

            if (checked) {
                this.$emit('generateAuthenticationKey');
            } else {
                this.$emit('resetAuthenticationKey');
            }
        }
    }
};
</script>
